import * as Yup from "yup";

export const simplePassword = {
  password: Yup.string()
    .matches(/(?=.*\d)/, "Password must be at least 1 numeric value")
    .matches(/(?=.*[A-Z])/, "Password must be at least 1 capital letter")
    .matches(/(?=.*[-+_!@#$%^&*.,?])/, "Password must be at least 1 special character")
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
};

export const passwordValidations = {
  ...simplePassword,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required"),
};
